/*
GUIDEINTERNAL_* actions are to be used by Guide module only, and are of no interest for
  any other module

GUIDEINTERNAL_UPDATE_CHANNEL_LIST_POS:
  Stores the Y position of each channel on the guide/list. It's to avoid recalculating each time
    the channel-guide is scrolled.
  We can not use Core's state.linearChannels as in the Guide, the same channel can appear more
    than once (ie in Features category and in it's own category). For such channels (as the ID
    is the same), the Y-position will be the same for the channel instance in the Features
    category and its real category.

GUIDEINTERNAL_FEATURED_CATEGORY_SEGMENT:
  Sets the start/end indexes (on the channelList) of the Featured category. This is necessary as
  the CategoryBar behaves differently for Featured than for other categories
 */

const ActionTypes = {
  GUIDEINTERNAL_UPDATE_CHANNEL_LIST_POS: 'GUIDEINTERNAL_UPDATE_CHANNEL_LIST_POS',
  GUIDEINTERNAL_FEATURED_CATEGORY_SEGMENT: 'GUIDEINTERNAL_FEATURED_CATEGORY_SEGMENT',
  CHANGE_CHANNEL_DIRECTION: 'CHANGE_CHANNEL_DIRECTION',
};

export default ActionTypes;
